import React, { Component } from 'react';
import bwipjs from 'bwip-js';

class BarCodeUtil extends Component {

    componentDidMount() {

        const options = {
            bcid: this.props.type === undefined ? 'code128' : this.props.type,
            text: this.props.texto,
            scale: 1,
            height: 8,
            includetext: false,
            textxalign: 'center',
        };

        bwipjs(this._getId(), options, () => { });
    }

    _getId() {
        return `barcode_${this.props.id}`;
    }

    render() {
        return <canvas id={this._getId()}></canvas>
    }

}

export default BarCodeUtil;


// WEBPACK FOOTER //
// ./src/app/common/util/barcode.util.js